// extracted by mini-css-extract-plugin
module.exports = {"form-group":"_-2xt1cZ","form-group__label":"_-1o7hv8"};